var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCalendarSmall = function SvgIconCalendarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14143C",
    fillRule: "evenodd",
    d: "M17.7 6.4V5a1 1 0 0 0-1-1h-.3a1 1 0 0 0-1 1v1.4H9.2V5a1 1 0 0 0-1-1h-.3a1 1 0 0 0-1 1v1.4H5v2h15v-2h-2.3ZM5 9.3v10.1h15V9.3H5Zm4.2 8.1H6.9v-2.3h2.3v2.3Zm0-3.8H6.9v-2.3h2.3v2.3Zm4.4 3.8h-2.3v-2.3h2.3v2.3Zm0-3.8h-2.3v-2.3h2.3v2.3Zm4.1 3.8h-2.3v-2.3h2.3v2.3Zm0-3.8h-2.3v-2.3h2.3v2.3Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCalendarSmall;